const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "table.superadmin_boq_supply_type_groups/SET_TABLE_PARAMS":
            return {
                ...state,
                ...action.params
            };
        case "table.superadmin_boq_supply_type_groups/LIST_BOQ_SUPPLY_TYPE_GROUPS_SUCCESS":
            return {
                ...state,
                data: action.response.data,
                filters: action.response.filters,
                ...action.response.pagination
            };
        default:
            return state;
    }
}
